"use client";

import { useTranslations } from "next-intl";
import styles from "./SkipLink.module.css";

/**
 * Skip Links Component
 *
 * Provides keyboard users with multiple skip link targets to bypass
 * repetitive navigation and jump to key page sections.
 *
 * WCAG 2.4.1 (Level A) - Bypass Blocks
 *
 * Skip link targets:
 * - Main content (#main-content)
 * - Navigation (#main-navigation)
 * - Footer (#site-footer)
 *
 * The links are visually hidden until focused, then appear at the
 * top of the viewport for keyboard users.
 */
export default function SkipLink() {
  const t = useTranslations("accessibility");

  return (
    <div className={styles.skipLinkContainer} data-skip-link>
      <a href="#main-content" className={styles.skipLink}>
        {t("skipToMain")}
      </a>
      <a href="#main-navigation" className={styles.skipLink}>
        {t("skipToNav")}
      </a>
      <a href="#site-footer" className={styles.skipLink}>
        {t("skipToFooter")}
      </a>
    </div>
  );
}
